import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { FormCard } from '../../../components'
import { Button, Icon } from '@salesforce/design-system-react'

const CompanyForm = ({ formData, onEditButtonClicked }) => {
  return (
    <FormCard
      header='Company Details'
      readOnly={true}
      icon={<Icon category='standard' name='account' />}
      form={formData}
      onInputChanged={onEditButtonClicked}
      headerActions={<Button label='Edit' onClick={onEditButtonClicked} />}
    />
  )
}

CompanyForm.propTypes = {
  formData: PropTypes.object,
  onEditButtonClicked: PropTypes.func
}

export default memo(CompanyForm)
